import { DataProject } from "./DataProject";
import { DataService } from "./DataService";

export const DataNav = [
  { id: 1, label: "Accueil", link: "/", breadcrumb: "", breadcrumbImg: "" },
  {
    id: 2,
    label: "A Propos",
    link: "/a_propos",
    breadcrumb: "A Propos De Nous",
    breadcrumbImg: "assets/images/breadcrumb/breadcrumb-bg-1.png",
  },
  {
    id: 3,
    label: "Départements",
    link: "/departements",
    depDetails: [
      { id: DataService.item1.id, label: DataService.item1.title },
      { id: DataService.item2.id, label: DataService.item2.title },
      { id: DataService.item3.id, label: DataService.item3.title },
      { id: DataService.item4.id, label: DataService.item4.title },
    ],
    breadcrumb: "Nos Departements",
    breadcrumbImg: "assets/images/breadcrumb/breadcrumb-bg-1.png",
  },
  {
    id: 4,
    label: "Réalisations",
    link: "/realisations",
    breadcrumb: "Nos Réalisations",
    breadcrumbImg: "assets/images/breadcrumb/breadcrumb-bg-1.png",
  },
  {
    id: 5,
    label: "Recrutement",
    link: "/recrutement",
    breadcrumb: "Recrutement",
    breadcrumbImg: "assets/images/breadcrumb/breadcrumb-bg-1.png",
  },
  {
    id: 7,
    label: "Politique Qualité",
    link: "/politique_qualite",
    breadcrumb: "Notre Politique & Démarche Qualité",
    breadcrumbImg: "assets/images/breadcrumb/breadcrumb-bg-1.png",
  },
  {
    id: 6,
    label: "Contact",
    link: "/contact",
    breadcrumb: "Contactez Nous",
    breadcrumbImg: "assets/images/breadcrumb/breadcrumb-bg-1.png",
  },
];
